import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { USER_RESPONSES } = API_URLS;

//Getting user responses detail by customerId
const getUserResponseByCustomerId = (customerId, externalId, body) => {
  return postRequest(
    `${USER_RESPONSES.BASE}/${customerId}/${externalId}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting order detail by order id
const getOrderDetailByOrderId = (orderId) => {
  return postRequest(`${USER_RESPONSES.GET_ORDER_DETAILS}/${orderId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const consumerResponsesService = {
  getUserResponseByCustomerId,
  getOrderDetailByOrderId,
};
